/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-settings/content-control-studio-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 90vw;
  height: 80vh;
}
/*# sourceMappingURL=content-control-studio-settings.component.css.map */
